//
//
//
//
//
//
//

export default {
  props: {
    content: {
      type: String
    }
  },
  data: function data() {
    return {
      tooltipStyle: {
        top: -1000,
        right: -1000,
        display: 'none'
      }
    };
  },
  methods: {
    showTooltip: function showTooltip(event) {
      var rect = event.target.getBoundingClientRect();
      var x = rect.left + window.scrollX;
      var y = rect.top + window.scrollY;
      this.tooltipStyle = {
        top: "".concat(y + 25, "px"),
        right: "".concat(document.body.clientWidth - x - 17, "px"),
        display: 'block'
      };
    },
    hideTooltip: function hideTooltip() {
      this.tooltipStyle.display = 'none';
    }
  }
};